// libraries
import React, { useState } from 'react'
import clsx from 'clsx'
import { useFormContext, RegisterOptions } from 'react-hook-form'

// svg
import { GeneralWarning } from '/react4xp/components/Svg/Icons/General'
import { UxAngleDown } from '/react4xp/components/Svg/Ux/Angle'

interface SelectProps {
    id: string
    name: string
    label?: string
    placeholder?: string
    required?: boolean
    defaultValue?: string
    disabled?: boolean
    size?: 'small' | 'medium' | 'large' | 'full-width'
    className?: string
    errorMessages?: {
        required?: string
    }
    children?: React.ReactNode
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

export default function Select({
    id,
    name,
    label,
    required,
    defaultValue,
    disabled,
    size = 'full-width',
    className,
    errorMessages,
    children,
    onChange = () => {}
}: SelectProps) {

    const formContext = useFormContext()
    const register = formContext ? formContext.register : () => ({})
    const errors = formContext ? formContext.formState.errors : {}

    let validations: RegisterOptions = {
        onChange: (e) => onChange(e)
    }

    if (required) {
        validations.required = errorMessages?.required
    }

    const errorMessage = errors && errors[name]?.message

    return (
        <div className={clsx(
            'form-line',
            className,

            // input size
            size === 'small' && 'form-line--small',
            size === 'medium' && 'form-line--medium',
            size === 'large' && 'form-line--large',
            size === 'full-width' && 'form-line--full-width',
            
            errors && errors[name] && 'form-line--error'
        )}>

            <label className={clsx('form-line__label text-small')} htmlFor={id}>
                {label}
            </label>

            <div className='form-line__line-wrapper'>

                <select
                    id={id}
                    name={name}
                    className='form-line__input form-line__input--select text-small'
                    defaultValue={defaultValue}
                    disabled={disabled || false}
                    onChange={onChange}
                    {...(register ? register(name || '', validations) : {})}
                >
                    {children}
                </select>

                <div className='form-line__side-icon'>
                    <UxAngleDown />
                </div>

            </div>

            {errorMessage && (
                <p className={clsx('form-line__error-message', 'text-smaller')}>
                    <GeneralWarning />
                    {typeof errorMessage === 'string' && errorMessage}
                </p>
            )}

        </div>
    )
}